// Date string is YYYY-MM-DD
export function formatDateString(date) {
  return (new Date(date))
    .toLocaleString('en-US', { timeZone: 'UTC', day: '2-digit', month: 'short', year: 'numeric', weekday: 'short' });
}
